module.exports = __webpack_public_path__ + "static/media/dropdown_menu_general.9e218629.svg";